import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const NetworkONTRoutes = defineRoute({
    record: {
        route: {
            path: "/network-ont",
            component: () => loadView(import("./NetworkONTTable.vue")),
        },
    },
    detail: {
        route: {
            path: "/network-ont/:id",
            component: () => loadView(import("./NetworkONTDetail.vue")),
        },
        build(id: string) {
            return `/network-ont/${id}`;
        },
    },
});
